import {Component, OnInit, ElementRef, Renderer, OnDestroy} from '@angular/core';
import {ActivitiesService} from "./activities.service";
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { TaskService } from '@app/core/services/task.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationService } from '@app/core/services';

declare var $: any;

@Component({
  selector: 'sa-activities',
  templateUrl: './activities.component.html',
  providers: [ActivitiesService],
})
export class ActivitiesComponent implements OnInit {
  count:number;
  lastUpdate:any;
  active:boolean;
  activities:any;

  currentActivity: any;
  loading: boolean;

  //orders:AngularFireList<{}>;
  tab:string;
  
  orders:any;
  countOrders:number = 0;

  constructor(
    private el:ElementRef,
    private renderer: Renderer,
    private activitiesService:ActivitiesService,
    private taskService: TaskService,
    public af: AngularFireDatabase,
    private ns: NotificationService
    ) {
    this.active = false;
    this.loading = false;
    this.activities = [];
    this.count = 0;
    this.lastUpdate = new Date();


    let itemsRef = af.list('tasks', ref => ref.orderByChild('worker').equalTo('scheduledOrder'));
    // Use snapshotChanges().map() to store the key
    this.orders = itemsRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
     )
   );
    
  }

  ngOnInit() {

  
   this.tab = 'orders';

    this.activitiesService.getActivities().subscribe(data=> {
      this.activities = data;
      this.count = data.reduce((sum, it)=> sum + it.data.length, 0);
      this.currentActivity = data[0];
    });

  }

  setActivity(activity){
    this.currentActivity = activity;
  }

  private documentSub: any;
  onToggle() {
    let dropdown = $('.ajax-dropdown', this.el.nativeElement);
    this.active = !this.active;
    if (this.active) {
      dropdown.fadeIn()


      this.documentSub = this.renderer.listenGlobal('document', 'mouseup', (event) => {
        if (!this.el.nativeElement.contains(event.target)) {
          dropdown.fadeOut();
          this.active = false;
          
        }
      });


    } else {
      dropdown.fadeOut()

      
    }
  }

  confirmDeleteOrder(order){
    this.ns.smartMessageBox({
      title: "Confirmación de acción!",
      content: "Confirma  eliminar la tarea programada seleccionada a nombre de " + order.opts.request.clientName,
      buttons: '[No][Si]'
    }, (ButtonPressed) => {
      if (ButtonPressed === "Si") {
        this.deleteOrder(order);        
      }
      if (ButtonPressed === "No") {        
      }
    });
  }

  deleteOrder(order){
    this.taskService.deleteTask(order.key);
  }

}
